import type { components } from './generated/schema';
import { apiRequest } from './client';

type LoginRequest = components['schemas']['LoginRequest'];
type RequestPasswordResetRequest = components['schemas']['RequestPasswordResetRequest'];
type RequestPasswordResetResponse = components['schemas']['RequestPasswordResetResponse'];
type VerifyPasswordResetCodeRequest = components['schemas']['VerifyPasswordResetCodeRequest'];
type VerifyPasswordResetCodeResponse = components['schemas']['VerifyPasswordResetCodeResponse'];
type CompletePasswordResetRequest = components['schemas']['CompletePasswordResetRequest'];
export type TokenPairResponse = components['schemas']['TokenPairResponse'];
export type CurrentUser = components['schemas']['UserResponse'] & {
  readonly avatar_url: string | null;
  readonly phone_number?: string | null;
  readonly telegram_username?: string | null;
};

export function login(request: LoginRequest): Promise<TokenPairResponse> {
  return apiRequest<TokenPairResponse>('/auth/login', { method: 'POST', body: request });
}

export function refresh(refreshToken: string): Promise<TokenPairResponse> {
  return apiRequest<TokenPairResponse>('/auth/refresh', {
    method: 'POST',
    body: { refresh_token: refreshToken },
  });
}

export function logout(refreshToken: string): Promise<void> {
  return apiRequest<void>('/auth/logout', {
    method: 'POST',
    body: { refresh_token: refreshToken },
  });
}

export function getCurrentUser(accessToken: string): Promise<CurrentUser> {
  return apiRequest<CurrentUser>('/auth/me', { token: accessToken });
}

// Admin-only: emails a code plus a CRM reset link. Mobile keeps using
// /auth/password-reset/request; verify-code and complete are shared.
export function requestAdminPasswordReset(
  request: RequestPasswordResetRequest,
): Promise<RequestPasswordResetResponse> {
  return apiRequest<RequestPasswordResetResponse>('/auth/admin/password-reset/request', {
    method: 'POST',
    body: request,
  });
}

export function verifyPasswordResetCode(
  request: VerifyPasswordResetCodeRequest,
): Promise<VerifyPasswordResetCodeResponse> {
  return apiRequest<VerifyPasswordResetCodeResponse>('/auth/password-reset/verify-code', {
    method: 'POST',
    body: request,
  });
}

export function completePasswordReset(request: CompletePasswordResetRequest): Promise<void> {
  return apiRequest<void>('/auth/password-reset/complete', {
    method: 'POST',
    body: request,
  });
}
